import { withJWTClient } from "../connectClient";

import {
  GetBlueprintResponseSchema,
  ListBlueprintsResponseSchema,
  type BlueprintMessage,
  type ListBlueprintsResponse,
} from "@/types/creativesphere";

const API_BASE_URL: string = import.meta.env.VITE_CREATIVESPHERE_API_URL || "";

/**
 * GET /v1/{siteId}/blueprints — the blueprint library backing the Step 2
 * picker grid. Each blueprint carries a `seeds_map`, `thumbnail_url` and
 * `name`/`description`.
 */
export async function listBlueprints(
  siteId: string,
): Promise<ListBlueprintsResponse> {
  const response = await withJWTClient((client) =>
    client.get<unknown>(`${API_BASE_URL}/v1/${siteId}/blueprints`),
  );
  return ListBlueprintsResponseSchema.parse(response.data);
}

/**
 * GET /v1/{siteId}/blueprints/{blueprintId} — a single blueprint, wrapped in a
 * `{ blueprint }` envelope (like Generate's `{ generation }`).
 */
export async function getBlueprint(
  siteId: string,
  blueprintId: string,
): Promise<BlueprintMessage> {
  const response = await withJWTClient((client) =>
    client.get<unknown>(
      `${API_BASE_URL}/v1/${siteId}/blueprints/${blueprintId}`,
    ),
  );
  return GetBlueprintResponseSchema.parse(response.data).blueprint;
}
